import { render } from "./AddProductGroup.vue?vue&type=template&id=91d5d242&ts=true"
import script from "./AddProductGroup.vue?vue&type=script&lang=ts"
export * from "./AddProductGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__